import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const schema = () => {
  const { t } = useTranslation('create_new_password');
  return yup.object().shape({
    code: yup.string().required(t('required_code')),
  });
};
